"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Tags = _ref => {
  let {
    className,
    size,
    addons,
    children
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: `tags${className ? ` ${className}` : ''}${size ? ` are-${size}` : ''}${addons ? ' has-addons' : ''}`
  }, children);
};
Tags.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]).isRequired,
  className: _propTypes.default.string,
  size: _propTypes.default.oneOfType([_propTypes.default.oneOf(['normal', 'medium', 'large']), _propTypes.default.string]),
  addons: _propTypes.default.bool
};
var _default = exports.default = Tags;
//# sourceMappingURL=Tags.js.map